import React from "react"
import { Link } from "gatsby"

import MainLayout from "../components/layout"
import SEO from "../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../components/SubPages/IntroSubPages/introSubPages"
import TextBelowIntro from "../components/SubPages/Covid19NewsPage/belowIntroText"
import Solutions from "../components/SubPages/Covid19NewsPage/covid19Solutions/covid19Solutions"

import backgroundImg from "../images/covid19/background.svg"

import PlatformImg from "../images/covid19/Platform for Conference.png"
import webConImg from "../images/covid19/Webconference.png"
import screenImg from "../images/covid19/Screen record.png"
import remoteDescktopImg from "../images/covid19/Remote Control.png"
import onlineTutImg from "../images/covid19/Tutoring.png"
import TeleMedicineImg from "../images/covid19/Telemedicine- Covid 19.png"

const Covid19Page = props => {
  const Platform = [
    {
      description: "Service:",
      linkName: "Custom Communication Systems",
      link: "https://meetrix.io/services/custom-communication-system/",
    },
    {
      description: "Product:",
      linkName: "Meetrix Meet",
      link: "https://meet.meetrix.io/",
    },
    {
      description: "Demo:",
      linkName: "Video Conference",
      link: "https://app.meet.meetrix.io/demo",
    },
    {
      description: "Demo:",
      linkName: "Platform",
      link: "https://meeting.meetrix.io/signup",
    },
  ]

  const webCon = [
    {
      description: "Demo:",
      linkName: "Video Conference",
      link: "https://app.meet.meetrix.io/demo",
    },
  ]

  const screen = [
    {
      description: "Product:",
      linkName: "ScreenApp",
      link: "https://screenapp.io/",
    },
    {
      description: "Blog:",
      linkName: "Top Features of ScreenApp",
      link:
        "https://screenapp.io/blog/features/01-top-3-reasons-to-use-online-screen-recorder.html",
    },
    {
      description: "Blog:",
      linkName: "How to record on Mac",
      link:
        "https://screenapp.io/blog/how-to/03-how-to-screen-record-on-Mac.html",
    },
    {
      description: "Blog:",
      linkName: "How to record on Windows",
      link:
        "https://screenapp.io/blog/how-to/01-how-to-screen-record-on-windows.html",
    },
    {
      description: "Blog:",
      linkName: "How to record on Ubuntu",
      link:
        "https://screenapp.io/blog/how-to/03-how-to-screen-record-on-Ubuntu.html",
    },
    {
      description: "Blog:",
      linkName: "How to record a browser tab",
      link:
        "https://screenapp.io/blog/how-to/08-how-to-record-a-browser-tab.html",
    },
  ]
  const remoteDescktop = [
    {
      description: "Product:",
      linkName: "Remotrix",
      link: "https://remotrix.meetrix.io/",
    },
    {
      linkName: "Free download for Windows",
      link:
        "https://remotrix-publish-dev.s3-us-west-2.amazonaws.com/Remortrix%20Setup%200.5.0.exe",
    },
    {
      description: "Blog:",
      linkName: "Download and Install Remotrix",
      link:
        "https://remotrix.meetrix.io/blog/how-to/01-download-and-install-remotrix.html",
    },
    {
      description: "Blog:",
      linkName: "How to control another desktop",
      link:
        "https://remotrix.meetrix.io/blog/how-to/02-how-to-control-another-desktop.html",
    },
    {
      description: "Blog:",
      linkName: "How to share my desktop",
      link:
        "https://remotrix.meetrix.io/blog/how-to/03-how-to-share-my-desktop.html",
    },
  ]

  const onlineTut = [
    {
      description: "Product:",
      linkName: "Meetrix Teach",
      link: "https://teach.meetrix.io/",
    },
    {
      description: "Solution:",
      linkName: "Online Tutoring",
      link: "https://meetrix.io/solutions/online-tutoring/",
    },
    {
      description: "Blog:",
      linkName: "Virtual Classroom",
      link:
        "https://dev.teach.meetrix.io/blog/how-to/01-virtual-class-room.html",
    },
    {
      description: "Blog:",
      linkName: "Class Scheduling and Management",
      link:
        "https://dev.teach.meetrix.io/blog/how-to/01-class-scheduling-and-management.html",
    },
    {
      description: "Blog:",
      linkName: "User Management",
      link: "https://dev.teach.meetrix.io/blog/how-to/01-user-management.html",
    },
    {
      linkName: "How to Sign Up for Meetrix Teach",
      link:
        "https://dev.teach.meetrix.io/blog/how-to/01-how-to-signup-to-meetrix-teach.html",
    },
    {
      description: "Service:",
      linkName: "How to Register Student",
      link:
        "https://dev.teach.meetrix.io/blog/how-to/02-how-to-register-student.html",
    },
    {
      linkName: "How to Schedule a Class",
      link:
        "goohttps://dev.teach.meetrix.io/blog/how-to/06-how-to-schedule-a-class.htmlgle",
    },
    {
      linkName: "How to Generate and Download Reports",
      link:
        "https://dev.teach.meetrix.io/blog/how-to/11-how-to-generate-and-download-reports.html",
    },
    {
      linkName: "How to assign Admin Roles",
      link:
        "https://dev.teach.meetrix.io/blog/how-to/12-how-to-assign-admin-roles.html",
    },
  ]

  const TeleMedicine = [
    {
      description: "Solution:",
      linkName: "TeleMedicine",
      link: "https://meetrix.io/solutions/telemedicine/",
    },
    {
      description: "Product:",
      linkName: "Meetrix Meet",
      link: "https://meet.meetrix.io/",
    },
    {
      description: "Demo:",
      linkName: "Video Conference",
      link: "https://app.meet.meetrix.io/demo",
    },
  ]
  return (
    <MainLayout>
      <SEO
        title="Work Remotely during COVID-19 pandemic"
        description="Work Remotely during COVID-19 pandemic"
        pagePath="/work-remotely-during-covid19"
        schema={`{
              "@context": "https://meetrix.io/work-remotely-during-covid19",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
      />
      <Intro
        title="Work Remotely during COVID-19 pandemic"
        description="A complete video conference solution with high-resolution video quality, protected meeting rooms, dial in with SIP phones or PSTN numbers, mobile apps for android and ios, scheduled meetings, calendar integration, user management, and more features. It can be white-labeled and used under your brand. It can be integrated with your current web app and will share your current user base"
        blueTitle="CONTACT SALES"
        blueLink=""
        // yellowTitle="BUILD PARTNERSHIP"
        // yellowLink="/partners"
        background={backgroundImg}
      />
      <TextBelowIntro description="Whether you want a white-labeled video conference solution built for you, use an online screen recorder to get updates from your employees, provide technical support by remotely accessing your client’s computer or want your current communication platform to scale to meet the increasing demands, we got it all covered." />
      <Solutions
        title="Platform for conferences"
        description="A complete video conference solution with high-resolution video quality, protected meeting rooms, dial in with SIP phones or PSTN numbers, mobile apps for android and ios, scheduled meetings, calendar integration, user management, and more features. It can be white-labeled and used under your brand. It can be integrated with your current web app and will share your current user base."
        image={PlatformImg}
        data={Platform}
        blue
      />

      <Solutions
        title="Web Conference"
        description="A web conference that can be customized white-labeled and hosted on your servers. Includes all features required to hold a quality, reliable and scalable conference. Supports all browsers for desktop and ios and android apps for mobile."
        image={webConImg}
        data={webCon}
        reverse
      />

      <Solutions
        title="Screen Recording"
        description="Get daily updates from your employees or describe tasks without having a meeting through screen recording. It is completely web-based and FREE for commercial use. No downloads or extensions needed."
        image={screenImg}
        data={screen}
        blue
      />

      <Solutions
        title="Remote Desktop Control"
        description="State of the art remote desktop control software for Windows, Mac, and Linux. Designed to be deployed in private networks without the internet. FREE for personal use."
        image={remoteDescktopImg}
        data={remoteDescktop}
        reverse
      />

      <Solutions
        title="Online Tutoring"
        description="The digitalization of the education industry has been slow yet promising with its large market. Meetrix Teach and Meetrix Virtual Classroom make this possible by providing students, tutors and, admins a great user experience through their well-designed tools. With the experience of producing online tutoring platforms that are major platforms driving the respective countries road to the digitalization of education, Meetrix is expertise and experienced to make your online tutoring dream a reality"
        image={onlineTutImg}
        data={onlineTut}
        blue
      />

      <Solutions
        title="TeleMedicine"
        description="The digital transformation of healthcare services looks to make it easier and faster for patients with lower costs. Conducting sessions online not only made it easier for patients without waiting in large queues but also reduced the costs since there is no charge made by the hospital or the medical institute. It has made these consulting services more accessible for the patients.Meetrix has catered this requirement with its expertise in real-time communication and developing custom web apps. With crystal clear audio and video conferences with low bandwidth healthcare services can leverage Meetrix to move their services online"
        image={TeleMedicineImg}
        data={TeleMedicine}
        reverse
      />
    </MainLayout>
  )
}

export default Covid19Page
